import React, { useEffect } from "react";
import bgImg from '../Images/prakruti-analysis.webp'
import Breadcrumb from "../Components/Breadcrumb";
import PrakrutiAnalysisForm from "../Components/PrakrutiAnalysisForm";
import Stats from "../Components/Stats";
import WhyChoose from "../Components/WhyChoose";
import Cta from "../Components/Cta";
import PrakrutiAnalysisSchema from "../Schema/PrakrutiAnalysisSchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";

const PrakrutiAnalysis=()=>{
     useEffect(() => {
            document.title =
              "Ayurvedic Body Type Quiz & Prakruti Analysis | Dr. Jigar Gor";
        
            const metaDesc = document.querySelector("meta[name='description']");
            if (metaDesc) {
              metaDesc.setAttribute(
                "content",
                "Discover your unique Ayurvedic body type! Take our quick Prakruti Analysis quiz by Dr. Jigar Gor in Bhuj to get personalized insights for a healthier life."
              );
            }
        
            const canonical = document.querySelector("link[rel='canonical']");
          if (canonical) {
            canonical.setAttribute("href", "https://msayurved.com/prakruti-analysis");
          }
        
          const ogTitle = document.querySelector("meta[property='og:title']");
          if (ogTitle) {
            ogTitle.setAttribute(
              "content",
              "Ayurvedic Body Type Quiz & Prakruti Analysis | Dr. Jigar Gor"
            );
          }
        
            const ogDesc = document.querySelector("meta[property='og:description']");
          if (ogDesc) {
            ogDesc.setAttribute(
              "content",
              "Discover your unique Ayurvedic body type! Take our quick Prakruti Analysis quiz by Dr. Jigar Gor in Bhuj to get personalized insights for a healthier life."
            );
          }
        
          const ogUrl = document.querySelector("meta[property='og:url']");
          if (ogUrl) {
            ogUrl.setAttribute("content", "https://msayurved.com/prakruti-analysis");
          }
        
            const ogImage = document.querySelector("meta[property='og:image']");
          if (ogImage) {
            ogImage.setAttribute(
              "content",
              "https://msayurved.com/Images/prakruti-analysis.webp"
            );
          }
        
            const twitterTitle = document.querySelector("meta[name='twitter:title']");
          if (twitterTitle) {
            twitterTitle.setAttribute(
              "content",
              "Ayurvedic Body Type Quiz & Prakruti Analysis | Dr. Jigar Gor"
            );
          }
        
            const twitterDesc = document.querySelector(
            "meta[name='twitter:description']"
          );
          if (twitterDesc) {
            twitterDesc.setAttribute(
              "content",
              "Discover your unique Ayurvedic body type! Take our quick Prakruti Analysis quiz by Dr. Jigar Gor in Bhuj to get personalized insights for a healthier life."
            );
          }
        
            const twitterImage = document.querySelector("meta[name='twitter:image']");
          if (twitterImage) {
            twitterImage.setAttribute(
              "content",
              "https://msayurved.com/Images/prakruti-analysis.webp"
            );
          }
          }, []);

const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "Prakruti Analysis",
      url: "https://msayurved.com/prakruti-analysis"
    },
  ];
    return(
        <>

        <PrakrutiAnalysisSchema />
        <BreadcrumbSchema items={breadcrumbItems} />

          {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title="Prakruti Analysis"
        bgImage={bgImg}
        />

        {/**ANALYSIS FORM */}
        <PrakrutiAnalysisForm/>

        {/**STATS SECTION */}
        <Stats />

        {/**WHY CHOOSE US SECTION */}
        <WhyChoose/>

        <div style={{marginBottom:"80px"}}></div>

        {/**CTA */}
        <Cta />
        </>
    )
}
export default PrakrutiAnalysis;